import React from 'react';
import { Server, Wifi, Activity, Users, HardDrive } from 'lucide-react';

const nodes = [
  { id: 'node-1', name: 'CCX33', ip: '5.78.227.36', type: 'Hetzner', status: 'online', cpu: 32, ram: 32, disk: '240 GB', load: 42 },
  { id: 'node-2', name: 'k8s-worker-1', ip: '10.0.0.12', type: 'Kubernetes', status: 'online', cpu: 8, ram: 16, disk: '120 GB', load: 28 },
  { id: 'node-3', name: 'edge-gpu-1', ip: '10.0.1.5', type: 'Edge', status: 'offline', cpu: 8, ram: 32, disk: '500 GB', load: 0 },
];

function ClusterSection() {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Cluster</h2>
        <p className="text-slate-400 mt-1">Distributed compute infrastructure</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="glass-panel p-6">
          <p className="text-xs text-slate-500 uppercase tracking-wider">Nodes</p>
          <p className="text-3xl font-bold text-white mt-2">{nodes.length}</p>
          <p className="text-xs text-green-400 mt-1">{nodes.filter(n => n.status === 'online').length} online</p>
        </div>
        <div className="glass-panel p-6">
          <p className="text-xs text-slate-500 uppercase tracking-wider">Total Compute</p>
          <p className="text-3xl font-bold text-white mt-2">48 vCPU</p>
          <p className="text-xs text-slate-500 mt-1">80 GB RAM</p>
        </div>
        <div className="glass-panel p-6">
          <p className="text-xs text-slate-500 uppercase tracking-wider">Services</p>
          <p className="text-3xl font-bold text-white mt-2">12</p>
          <p className="text-xs text-slate-500 mt-1">All operational</p>
        </div>
      </div>

      <div className="glass-panel divide-y divide-slate-800/50">
        <div className="p-6">
          <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider">Nodes</h3>
        </div>
        {nodes.map((node) => (
          <div key={node.id} className="p-5 hover:bg-slate-800/30 transition-colors">
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className={`w-3 h-3 rounded-full ${node.status === 'online' ? 'bg-emerald-500' : 'bg-red-500'}`} />
                <div>
                  <p className="text-white font-semibold">{node.name}</p>
                  <p className="text-xs text-slate-500">{node.ip} · {node.type}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 text-xs text-slate-500">
                <span className="flex items-center gap-1"><Cpu className="w-3 h-3" /> {node.load}%</span>
                <span className="flex items-center gap-1"><HardDrive className="w-3 h-3" /> {node.disk}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ClusterSection;
